<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px:height: auto !important;"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Inv / Exp Summary List</b-navbar-brand>

          <b-navbar-nav class="pull-right mr-auto">
            <b-nav-form>
              <!-- <ClientCard /> -->
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <b-card>
          <b-row class="mt-2">
            <b-col md="3">
              <label>Date Type</label>
              <model-list-select
                :list="dateStatusdataList"
                v-model="Filter.dateTypeFilter"
                option-value="inv"
                class="mt-2"
                option-text="int"
                placeholder="Select Date Type"
                @input="SearchFilter"
              ></model-list-select>
            </b-col>
            <b-col md="3">
              <label for="dateRange">Date</label>
              <date-range-picker
                :opens="openRight"
                :always-show-calendars="showCal"
                v-model="Filter.dateRange"
                :startDate="startDate"
                :endDate="endDate"
                :locale-data="locale"
                @update="SearchFilter"
              >
              </date-range-picker>
            </b-col>
            <b-col md="3">
              <label>Vendor</label>
              <model-list-select
                class="ml-1"
                :list="$store.getters['commonDropdownMaster/getAllTallyVendorList']"
                id="branchFilter"
                v-model="Filter.vendor_nameFilter"
                option-value="label"
                option-text="label"
                placeholder="Select Vendor"
                @input="SearchFilter"
                :isDisabled="
                  $sessionsStorage.get('designation') != 'Admin' &&
                  $sessionsStorage.get('nameUser') != 'Bhavneesh'
                    ? true
                    : false
                "
              ></model-list-select>
            </b-col>
            <b-col md="3">
              <label>Vendor GST</label>
              <model-list-select
                class="ml-1"
                :list="$store.getters['commonDropdownMaster/getAllTallyVendorGstList']"
                id="branchFilter"
                v-model="Filter.vendor_gstFilter"
                option-value="vendor_add_Gstin"
                option-text="vendor_add_Gstin"
                placeholder="Select Vendor GST"
                @input="SearchFilter"
                :isDisabled="
                  $sessionsStorage.get('designation') != 'Admin' &&
                  $sessionsStorage.get('nameUser') != 'Bhavneesh'
                    ? true
                    : false
                "
              ></model-list-select>
            </b-col>
            <!-- <b-col md="3">
              <label for="clientName">Client</label>
              <model-list-select
                :list="$store.getters['common/getAllClientList']"
                id="clientName"
                v-model="Filter.clientIdFilter"
                option-value="clientId"
                option-text="clientName"
                placeholder="Select Client Name"
                @input="SearchFilter"
              ></model-list-select>
            </b-col> -->
            <b-col md="3">
              <label>Ledger Group</label>
              <model-list-select
                :list="ledgerGRPTypeList"
                v-model="Filter.ledgerGRPTypeFilter"
                option-value="inv"
                class="mt-2"
                option-text="int"
                placeholder="Select Ledger Group"
                @input="SearchFilter"
              ></model-list-select>
            </b-col>
            <!-- <b-col md="3">
              <label>Container Type</label>
              <model-list-select
                :list="$store.getters['common/getAllContainerTypeList']"
                v-model="Filter.containerTypeFilter"
                option-value="containerTypeId"
                option-text="containerType"
                placeholder="Select Container Type"
                @input="SearchFilter"
              ></model-list-select>
            </b-col> -->

            <b-col md="3">
              <label>Voucher Type.</label>
              <b-form-input
                :formatter="capitalizeAll"
                class="mt-2"
                v-model="Filter.voucherTyype"
                placeholder="Enter Voucher Type"
                @input="SearchFilter"
              ></b-form-input>
            </b-col>
            <b-col md="3">
              <label>Voucher No.</label>
              <b-form-input
                class="mt-2"
                :formatter="capitalizeAll"
                v-model="Filter.InvoiceNoFilter"
                placeholder="Enter Voucher Number"
                @input="SearchFilter"
              ></b-form-input>
            </b-col>
            <b-col md="3">
              <label>Assignment No.</label>
              <b-form-input
                :formatter="capitalizeAll"
                class="mt-2"
                v-model="Filter.assignmentFilter"
                placeholder=" Assignment No."
                @input="SearchFilter"
              ></b-form-input>
            </b-col>

            <b-col md="3">
              <label>Common Search.</label>
              <b-form-input
                class="mt-2"
                :formatter="capitalizeAll"
                v-model="Filter.CommonFilter"
                placeholder="Common BL/Container Search"
                @input="SearchFilter"
              ></b-form-input>
            </b-col>
            <b-col md="3">
              <label>Exp/Inv Status</label>
              <model-list-select
                :list="invoiceStatusdataList"
                v-model="Filter.invstatusFilter"
                option-value="inv"
                class="mt-2"
                option-text="int"
                placeholder="Select Status"
                @input="SearchFilter"
              ></model-list-select>
            </b-col>
            <!-- <b-col md="3">
              <label>Branch</label>
              <model-list-select
                class="ml-1"
                :list="$store.getters['common/getAllBranchList']"
                id="branchFilter"
                v-model="Filter.branchFilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="All"
                @input="SearchFilter"
                :isDisabled="
                  $sessionsStorage.get('designation') != 'Admin' &&
                  $sessionsStorage.get('nameUser') != 'Bhavneesh'
                    ? true
                    : false
                "
              ></model-list-select>
            </b-col> -->

            <b-col md="12" class="mt-2">
              <center>
                <b-button size="sm" @click="SearchFilter" variant="outline-primary"
                  >Search</b-button
                >
                <b-button
                  size="sm"
                  class="ml-3"
                  @click="clearFilter"
                  variant="outline-info"
                  >Clear</b-button
                >

                <b-button
                  class="pull-right mb-1"
                  v-if="PLInvExpList.length > 0"
                  :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
                  @click="getReports('Expense_BILLING', 'Export As Excel')"
                  size="sm"
                  variant="warning"
                >
                  {{ ExcelBtnName }}
                  <b-spinner
                    v-if="ExcelBtnName != 'Export As Excel'"
                    small
                    label="Small Spinner"
                  ></b-spinner
                ></b-button>
              </center>
            </b-col>
          </b-row>
        </b-card>

        <div class="box">
          <div>
            <b-pagination
              limit="8"
              align="center"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total-rows="totalRows"
              @change="onPageChange($event)"
            ></b-pagination>
          </div>

          <div class="gutr">
            <h5 class="text-muted pull-right mt-2">
              <small v-if="isLoading == false">{{ totalRows }} Entries</small>
            </h5>
          </div>

          <div class="table-responsive tableMain gutr">
            <b-table
              show-empty
              stacked="md"
              :items="PLInvExpList"
              responsive
              :fields="PLInvExpfields"
              primary-key="counter_id"
              :per-page="pagination.perPage"
              :current-page="pagination.currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              class="position-relative"
            >
              <template slot="SN" slot-scope="row0">
                <span>{{
                  row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                }}</span>
              </template>
              <template slot="ledger_group_txt" slot-scope="row6">
                <div class="text-left" v-if="row6.item.ledger_group_txt">
                  <div v-if="row6.item.ledger_group_txt">
                    <span
                      v-for="(item1, index1) in row6.item.ledger_group_txt.split(',')"
                      :key="index1"
                    >
                      <h6>
                        <b-badge variant="light"
                          >{{ item1 == "" ? "-------" : item1 }}
                        </b-badge>
                      </h6>
                    </span>
                  </div>
                </div>
                <div class="text-left" v-else>
                  <b-badge variant="light">-------</b-badge>
                </div>
                <span>Create Date : {{ row6.item.createdDate }}<br /></span>
                <span>Updated Date : {{ row6.item.updatedDate }}<br /></span>
                <span>Item Create Date : {{ row6.item.itemcreatedDate }}<br /></span>
                <span>Item Updated Date : {{ row6.item.itemupdatedDate }}<br /></span>
              </template>
              <template slot="unique_id" slot-scope="row11">
                <b-button
                  style="font-size: 0.675rem"
                  class="mt-2 mb-1x"
                  v-if="row11.item.unique_id"
                  size="sm"
                  @click="removeExpInv(row11.item)"
                  variant="outline-info"
                  >Remove</b-button
                >
              </template>
            </b-table>
          </div>
        </div>

        <div>
          <b-pagination
            limit="8"
            align="center"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total-rows="totalRows"
            @change="onPageChange($event)"
          ></b-pagination>
        </div>
      </b-card-text>
    </b-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat, wordWrap } from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import CommonService from "../../services/CommonService.js";
import CustomLoader from "../common/customLoader.vue";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    this.getCurrentLastDate();
    // let payload_curr = {
    //   Currency: "Currency_DropDown",
    // };
    // this.$store.dispatch("common/setAllCurrencyList", JSON.stringify(payload_curr));
    this.$store.dispatch(
      "commonDropdownMaster/setAllTallyVendorDDList",
      JSON.stringify({
        itemCode: "All_Vendor_List",
        Filter: { statusFilter: "1" },
        type: "Normal",
      })
    );
    this.$store.dispatch(
      "commonDropdownMaster/setAllTallyVendorGstDDList",
      JSON.stringify({
        itemCode: "All_Vendor_GST_List",
        Filter: { statusFilter: "1" },
        type: "Normal",
      })
    );
    //  this.$store.dispatch("common/setAllAgentColoaderList");
    // this.$store.dispatch(
    //   "common/setAllBranchList",
    //   JSON.stringify({
    //     filter: "BranchList",
    //    active: "all",
    //  })
    // );

    // this.$store.dispatch(
    //    "common/setAllClientList",
    //   JSON.stringify({
    //     itemCode: "ClientList",
    //   })
    // );
    // this.$store.dispatch(
    //   "common/setAllShippingLineList",
    //  JSON.stringify({
    //     itemCode: "ShippingLineList",
    //   })
    //  );

    // this.$store.dispatch(
    //    "common/setAllAirLineList",
    //    JSON.stringify({
    //      itemCode: "AirLineList",
    //   })
    //  );

    //  this.$store.dispatch(
    //    "common/setAllLocationDetailsFinalList",
    //   JSON.stringify({
    //     itemCode: "LocationDetailsFinalList",
    //   })
    // );
    // this.$store.dispatch(
    //   "common/setAllPORList",
    //   JSON.stringify({
    //    itemCode: "PORList",
    //  })
    // );
    // this.$store.dispatch(
    //   "common/setAllPODList",
    //   JSON.stringify({
    //     itemCode: "PODList",
    //    type: "Normal",
    //    Territory: "",
    //  })
    //  );
    //  this.$store.dispatch(
    //   "common/setAllPOLList",
    //   JSON.stringify({
    //     itemCode: "POLList",
    //  })
    // );

    this.$store.dispatch(
      "common/setAllContainerTypeList",
      JSON.stringify({
        itemCode: "ContainerTypeList",
      })
    );
    if (globalPermissionStatus("Accounts")) {
      this.$store.dispatch("setCurrentRoute", "/viewBillingDetails/viewBillingDetails");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.getAllExpenseList("Normal");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      Filter: {
        InvoiceNoFilter: "",
        clientIdFilter: "",
        assignmentFilter: "",
        CommonFilter: "",
        ContainerNoFilter: "",
        containerTypeFilter: "",
        InvoiceTypeFilter: "",
        BLNOFilter: "",
        ShipperINVFilter: "",
        ShippingBillLNOFilter: "",
        SlineFilter: "",
        airLineFilter: "",
        branchFilter: "",
        ClientFilter: "",
        PORFilter: "",
        POLFilter: "",
        PODFilter: "",
        FPODFilter: "",
        invstatusFilter: "1",
        dateTypeFilter: "Invoice",
        buyer_nameFilter: "",
        buyer_gstFilter: "",
        vendor_nameFilter: "",
        vendor_gstFilter: "",
        vendor_addressFilter: "",
        vendor_stateFilter: "",
        dateRange: { startDate: "", endDate: "" },
        ledgerGRPTypeFilter: "Income",
        voucherTyype: "",
      },
      docURL: URL_BASE_DOC,
      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),

      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openRight: "right",
      showCal: false,
      showDash: false,

      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      totalRows: 0,
      pagination: {
        currentPage: 1,
        perPage: 75,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      PLInvExpfields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "job_no",
          mainkey: "job_no",
          label: "JOBNO",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "inv_type",
          mainkey: "inv_type",
          label: "Voucher Type",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "inv_no",
          mainkey: "inv_no",
          label: "Voucher No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "inv_date",
          mainkey: "inv_date",
          label: "Voucher Date",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "INVStatus",
          mainkey: "INVStatus",
          label: "Voucher Status",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "ledger_group",
          mainkey: "ledger_group",
          label: "Ledger Group",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "ledger_group_txt",
          mainkey: "ledger_group_txt",
          label: "Ledger Group Text",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "customer_name",
          mainkey: "customer_name",
          label: "Customer Name",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "particulars",
          mainkey: "particulars",
          label: "Particulars",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
        {
          key: "exp_AMT",
          mainkey: "exp_AMT",
          label: "Expense",
          sortable: true,
          sortDirection: "ASC",
          table: "G.",
        },

        {
          key: "inv_AMT",
          mainkey: "inv_AMT",
          label: "Income",
          sortable: true,
          sortDirection: "ASC",
          table: "H.",
        },
        {
          key: "unique_id",
          mainkey: "unique_id",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          table: "H.",
        },
      ],
      PLInvExpList: [],

      isLoading: false,
      ExcelBtnName: "Export As Excel",
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },

      jobList: [
        {
          jv: "FF",
          jt: "FF",
        },
        {
          jv: "CC",
          jt: "CC",
        },
        {
          jv: "TPT",
          jt: "TPT",
        },
      ],
      invoiceStatusdataList: [
        {
          inv: "0",
          int: "All",
        },
        {
          inv: "1",
          int: "Active",
        },
        {
          inv: "2",
          int: "In-Active",
        },
      ],
      dateStatusdataList: [
        {
          inv: "Expense",
          int: "Expense",
        },
        {
          inv: "Invoice",
          int: "Invoice",
        },
        {
          inv: "Both",
          int: "Both",
        },
      ],

      ledgerGRPTypeList: [
        {
          inv: "Income",
          int: "Income",
        },
        {
          inv: "Expenses",
          int: "Expenses",
        },
        {
          inv: "Both",
          int: "Both",
        },
      ],
    };
  },

  mounted() {
    document.title = "Pridel | " + this.$route.name;
    console.log(this.$route.name);
    console.log(this.$route.path);
    console.log(this.$route.params);
    console.log(this.$route.query);
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
    CustomLoader,
  },

  computed: {},
  watch: {},
  methods: {
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      // alert(firstDay);
      // alert(lastDay);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      let firstYear = firstDay_mm > 3 ? firstDay_yyyy : firstDay_yyyy - 1;
      let newdate = firstYear + "-04-01";
      firstDay = new Date(newdate);

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      firstDay = new Date(today);
      // alert(today)
      // alert(firstDay)
      // alert(lastDay)
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      // alert(today);
    },
    getReports(id, btnName) {
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getAllExpenseList("Excell");
    },
    clearFilter() {
      (this.Filter = {
        InvoiceNoFilter: "",
        assignmentFilter: "",
        CommonFilter: "",
        ContainerNoFilter: "",
        containerTypeFilter: "",
        InvoiceTypeFilter: "",
        BLNOFilter: "",
        ShipperINVFilter: "",
        ShippingBillLNOFilter: "",

        clientIdFilter: "",
        SlineFilter: "",
        airLineFilter: "",
        branchFilter: "",
        ClientFilter: "",
        PORFilter: "",
        POLFilter: "",
        PODFilter: "",
        FPODFilter: "",
        invstatusFilter: "1",
        dateTypeFilter: "Invoice",

        pridel_nameFilter: "",
        pridel_gstFilter: "",
        pridel_addressFilter: "",
        pridel_stateFilter: "",
        buyer_nameFilter: "",
        buyer_gstFilter: "",
        vendor_nameFilter: "",
        vendor_gstFilter: "",
        vendor_addressFilter: "",
        vendor_stateFilter: "",
        dateRange: { startDate: "", endDate: "" },
        ledgerGRPTypeFilter: "Income",
        voucherTyype: "",
      }),
        this.getCurrentLastDate();
      this.getAllExpenseList("Normal");
    },
    getAllExpenseList(type) {
      this.PLInvExpList = [];
      this.totalRows = 0;
      this.isLoading = true;
      let payload = {
        itemCode: "getExpInvListDetails",
        Filter: this.Filter,
        type: type,
      };
      CommonService.getAllJobList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (type == "Excell") {
              this.ExcelBtnName = "Export As Excel";
              if (data.PLInvExpList.length > 0) {
                this.PLInvExpList = data.PLInvExpList;
                this.totalRows = data.PLInvExpList.length;
              }
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.PLInvExpList.length > 0) {
                this.PLInvExpList = data.PLInvExpList;
                this.totalRows = data.PLInvExpList.length;
                console.log(" getAllExpenseList response=>", data);
              }
            }
          } else {
            this.PLInvExpList = [];
          }
          this.isLoading = false;
          this.PaginationCount = this.pagination.perPage;
        })
        .catch((error) => {
          console.log("Catch on getAllExpenseList Error: ", error);
        });
    },
    SearchFilter(event) {
      if (this.Filter.assignmentFilter) {
        this.Filter.dateTypeFilter = "Both";
        this.Filter.ledgerGRPTypeFilter = "Both";
      }
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllExpenseList("Normal");
      }, 1000);
    },
    pagechangeData() {
      this.pagination.perPage = this.PaginationCount;
      this.getAllExpenseList("Normal");
    },
    wordWrap,
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getAllExpenseList("Normal");
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getAllExpenseList("Normal");
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.pagination.currentPage = 1;
    },
    viewExportFCLConPage(AM) {
      this.$sessionsStorage.set("editSalesExId", AM);

      this.$router.push({
        path: "/mainEnquiry/salesExecutionAll",
      });
    },
    removeExpInv(item) {
      this.isLoading = true;
      console.log("item=>",item)

      let payload = {
        itemCode: "removeExpInv",
        allModuleId: item.allModuleId,
        unique_id: item.unique_id,
        DeleteType: item.InvExpType,
      };

      console.log("paylod =>", payload);
      CommonService.getAllJobList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200) {
            this.isLoading = false;
            this.alert.content = data.msg;
            this.$refs["addPop"].open();
            this.getAllExpenseList("Normal");
          }
        })
        .catch((error) => {
          console.log("Catch on removeExpInv Error: ", error);
        });
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// itemExpInvList.vue?53f1c931